// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style for the action menu container */
::ng-deep.action-menu {
  position: relative;
  display: inline-block;
}

/* Style for the three dots icon */
::ng-deep.dots {
  cursor: pointer;
  font-size: 24px;
  display: block;
  margin: 0 auto;
  padding: 5px;
}

/* Style for the action buttons, hidden by default */
::ng-deep.action-buttons {
  position: absolute;
  top: 100%;
  right: -20px;
  background-color: white;
  padding: 10px;
  display: none;
  border-radius: 5px;
  z-index: 1;
}
::ng-deep.action-buttons ul {
  width: 100%;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);
  white-space: nowrap;
  position: relative;
  min-width: 130px;
  border-radius: 4px;
}
::ng-deep.action-buttons ul::before {
  content: "";
  position: absolute;
  right: 7px;
  bottom: 100%;
  background-color: #fff;
  width: 16px;
  height: 9px;
  clip-path: polygon(0 100%, 50% 0, 100% 100%);
}
::ng-deep.action-buttons ul li {
  border-bottom: 1px solid #e7eaec;
}
::ng-deep.action-buttons ul li button, ::ng-deep.action-buttons ul li a {
  display: block;
  border: 0;
  padding: 13px 17px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #676a6c;
  width: 100%;
  text-align: left;
}

/* Show the action buttons when hovered */
::ng-deep.action-menu:hover .action-buttons {
  display: block;
}

::ng-deep.action-buttons button {
  width: 100%;
  margin-bottom: 5px;
  padding: 8px;
}

::ng-deep.action-buttons button:last-child {
  margin-bottom: 0;
}

/* Style for buttons */
::ng-deep.btn {
  font-size: 14px;
  text-align: center;
  width: 100%;
  padding: 8px;
  border: none;
  cursor: pointer;
}

::ng-deep.ngx-datatable .datatable-body-cell, .ngx-datatable .datatable-header-cell {
  overflow-x: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ngx-table-format/ngx-table-format.component.scss"],"names":[],"mappings":"AAKA,wCAAA;AACA;EACE,kBAAA;EACA,qBAAA;AAJF;;AAOA,kCAAA;AACA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;AAJF;;AAOA,oDAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EAEA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AALF;AAOE;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAOI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;AALN;AAQI;EACE,gCAAA;AANN;AAQM;EACE,cAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AANR;;AAYA,yCAAA;AACA;EACE,cAAA;AATF;;AAYA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA,sBAAA;AACA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AATF;;AA2BA;EACI,8BAAA;AAxBJ","sourcesContent":["\n// ::ng-deep.pager { \n//     background-color: cadetblue;\n// }\n\n/* Style for the action menu container */\n::ng-deep.action-menu {\n  position: relative;\n  display: inline-block;\n}\n\n/* Style for the three dots icon */\n::ng-deep.dots {\n  cursor: pointer;\n  font-size: 24px;\n  display: block;\n  margin: 0 auto;\n  padding: 5px;\n}\n\n/* Style for the action buttons, hidden by default */\n::ng-deep.action-buttons {\n  position: absolute;\n  top: 100%;\n  right: -20px;\n  background-color: white;\n  // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  display: none;\n  border-radius: 5px;\n  z-index: 1;\n\n  ul {\n    width: 100%;\n    background-color: #fff;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.17);\n    white-space: nowrap;\n    position: relative;\n    min-width: 130px;\n    border-radius: 4px;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      right: 7px;\n      bottom: 100%;\n      background-color: #fff;\n      width: 16px;\n      height: 9px;\n      clip-path: polygon(0 100%, 50% 0, 100% 100%);\n    }\n\n    li {\n      border-bottom: 1px solid #e7eaec;\n\n      button,a {\n        display: block;\n        border: 0;\n        padding: 13px 17px;\n        background-color: transparent;\n        font-size: 12px;\n        font-weight: 600;\n        color: #676a6c;\n        width: 100%;\n        text-align: left;\n      }\n    }\n  }\n}\n\n/* Show the action buttons when hovered */\n::ng-deep.action-menu:hover .action-buttons {\n  display: block;\n}\n\n::ng-deep.action-buttons button {\n  width: 100%;\n  margin-bottom: 5px;\n  padding: 8px;\n}\n\n::ng-deep.action-buttons button:last-child {\n  margin-bottom: 0;\n}\n\n/* Style for buttons */\n::ng-deep.btn {\n  font-size: 14px;\n  text-align: center;\n  width: 100%;\n  padding: 8px;\n  border: none;\n  cursor: pointer;\n}\n\n// ::ng-deep.btn-primary {\n//   background-color: #007bff;\n//   color: white;\n// }\n\n// ::ng-deep.btn-danger {\n//   background-color: #dc3545;\n//   color: white;\n// }\n\n// ::ng-deep.btn-info {\n//   background-color: #17a2b8;\n//   color: white;\n// }\n\n::ng-deep.ngx-datatable .datatable-body-cell, .ngx-datatable .datatable-header-cell {\n    overflow-x: visible !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
